module.exports = __webpack_public_path__ + "static/media/TelekomRomania_Romania.95d5301d.png";